import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as Cab } from "../../Global Icons/Cab.svg";
import { useNavigate } from "react-router-dom";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountry,
  viewCountryListPagination,
} from "../../Redux/Actions/settingsActions";
import { ScrollTop, ToFirstCapital } from "../../Utils/helpers";
import { addCabCategory } from "../../Redux/Actions/cabRequestActions";
import toast from "react-hot-toast";
import TwoButtons from "../../Global Functions/buttons";
import { getEnums } from "../../Redux/Actions/enumsActions";
import AddImage from "../../Global Functions/addImage";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const AddCabCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { countryList, country } = useSelector((state) => state.country || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});

  const [cabState, setCabState] = useState({
    name: "",
    rate_per_unit: 0,
    rate_per_unit_measure_in: 0,
    currency: country?.data?.country_currency,
    type: "",
    image: "",
    status: "",
    round_trip_rate_per_unit: 0,
  });

  const cabSettingsNavigator = () => {
    navigate("/cab_settings");
  };

  const handleAddChange = async (event) => {
    const { name, value, files } = event.target;
    if (name === "image") {
      const file = files && files[0];
      if (!file) return;

      const res = await AddImage(file);
      if (res) {
        setCabState((prevData) => ({
          ...prevData,
          [name]: res,
        }));
      }
      return;
    }
    setCabState((prevData) => ({
      ...prevData,
      [name]: value,
      currency: country?.data?.country_currency,
    }));
  };

  useEffect(() => {
    ScrollTop();
    dispatch(viewCountryListPagination());
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    dispatch(viewCountry(cabState.country));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cabState?.country]);

  const handleSubmit = async () => {
    try {
      // if (
      //   Object.values(cabState).some(
      //     (value) => value === null || value === "" || value === undefined
      //   )
      // ) {
      //   return toast.error("Input fields cannot be empty!!");
      // }

      const response = await dispatch(addCabCategory(cabState));
      if (response.statusCode === 200) {
        navigate("/cab_settings");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 full-screen full-height">
        <InnerHeading
          Icon={Cab}
          heading="Add Cab Category"
          buttonLabel="View Categories"
          onClick={cabSettingsNavigator}
        ></InnerHeading>
        <TextInput
          label="Name"
          name="name"
          type="string"
          onChange={handleAddChange}
          required
        />
        <div style={{ width: "98%" }}>
          <SelectInput
            placeholder="Select an option"
            // required
            label={<span>
              Type<span style={{ color: "red" }}>*</span>
            </span>}
            value={cabState.type}
            min={0}
            onChange={handleAddChange}
            name="type"
            options={
              enumsData?.data?.cabIcons
                ? Object.entries(enumsData.data.cabIcons).map(([key, _]) => ({
                  label: ToFirstCapital(key),
                  value: key,
                }))
                : []
            }
          ></SelectInput>
        </div>
        <div style={{ width: "98%" }}>
          <SelectInput
            label={<span>
              Select Country<span style={{ color: "red" }}>*</span>
            </span>}
            placeholder="Select an Option"
            value={cabState.country}
            onChange={handleAddChange}
            // required
            name="country"
            options={
              Array.isArray(countryList?.data)
                ? countryList.data.map((country) => ({
                  label: country.country_name,
                  value: country._id,
                }))
                : []
            }
          ></SelectInput>
        </div>
        <TextInput
          disabled
          onChange={handleAddChange}
          name="currency"
          label="Currency"
          value={country?.data?.country_currency || ""}
        ></TextInput>
        <TextInput
          name="rate_per_unit"
          onChange={handleAddChange}
          label="Rate"
          value={cabState.rate_per_unit}
        ></TextInput>
        <TextInput
          name="round_trip_rate_per_unit"
          onChange={handleAddChange}
          label="Round trip rate per unit"
          value={cabState.round_trip_rate_per_unit}
        ></TextInput>

        <TextInput
          type="string"
          required
          name="rate_per_unit_measure_in"
          onChange={handleAddChange}
          label="Rate per unit measure in"
          value={cabState.rate_per_unit_measure_in}
        ></TextInput>
        <div style={{ width: "98%" }}>
          <SelectInput
            placeholder="Select Cab Status"
            // required
            label={<span>
              Status<span style={{ color: "red" }}>*</span>
            </span>}
            value={cabState.status}
            onChange={handleAddChange}
            name="status"
            options={[
              { label: "Active", value: "active" },
              { label: "Inactive", value: "inactive" }
            ]}
          />
        </div>
        <div style={{ width: "98%" }}>
          <SelectInput
            placeholder="Select number of seats"
            // required
            label={<span>
              No of Seats<span style={{ color: "red" }}>*</span>
            </span>}
            value={cabState.no_of_seats}
            onChange={handleAddChange}
            name="no_of_seats"
            options={[
              { label: "2", value: 2 },
              { label: "3", value: 3 },
              { label: "4", value: 4 },
              { label: "5", value: 5 },
              { label: "6", value: 6 },
              { label: "7", value: 7 },
            ]}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {/* File Upload Input */}
          <TextInput
            forImage={true}
            htmlFor="image"
            type="file"
            required
            span="Brand Logo"
            label="Click to Upload Image"
            id="image"
            name="image"
            onChange={handleAddChange}
          />
          {cabState.image && (
            <ImageShowerModalGlobal
              file={cabState.image}
              keyField="image"
              setState={setCabState}
              state={cabState}
            />
          )}
        </div>
        <div className="span2">
          <TwoButtons
            buttonHead1="Cancel"
            noUrl={true}
            LinkURL="/cab_settings"
            onClick2={() => handleSubmit()}
            buttonHead2="Save"
          ></TwoButtons>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCabCategory;
